import {TokenBody} from '../model/token-body';
import { ApplicationType, MaintenanceProductType, Permission } from '../enums/enums';
import { TokenApplication } from '../model/token-application';

export class TokenService {

  private token: string;
  private refreshToken: string;
  private decodedToken: TokenBody;

  public init(token: string, refreshToken: string) {
    this.token = token;
    this.refreshToken = refreshToken;
    this.decodedToken = this.decodeToken(token);
  }

  public getToken(): string {
    return this.token;
  }

  public getRefreshToken(): string {
    return this.refreshToken;
  }

  public getLoginId(): string {
    return this.decodedToken.LoginId;
  }

  public getExp(): number {
    return this.decodedToken.Exp;
  }

  public getUsername(): string {
    return this.decodedToken.Username;
  }

  public getFirstName(): string {
    return this.decodedToken.FirstName;
  }

  public getLastName(): string {
    return this.decodedToken.LastName;
  }

  public getCulture(): string {
    return (this.decodedToken != null && this.decodedToken.Culture != null) ? this.decodedToken.Culture : null;
  }

  public getCountry(): string {
    return (this.decodedToken != null && this.decodedToken.Country != null) ? this.decodedToken.Country : 'GB';
  }

  public getPermissions(): Permission[] {
    let permissions: Permission[] = [];
    let products = this.getProducts();
    if (products.includes(MaintenanceProductType.PRO)){
      permissions.push(Permission.INTERVENTIONS);
    }
    return permissions;
  }

  public getApplications(): TokenApplication[] {
    if (this.decodedToken && this.decodedToken.Applications) {
      return this.decodedToken.Applications;
    } else {
      return [];
    }
  }

  public getProducts(): MaintenanceProductType[] {
    if (this.decodedToken && this.decodedToken.Applications && this.decodedToken.Applications.length > 0) {
      let maintenanceApplication = this.decodedToken.Applications.find(a => a.Type == ApplicationType.MAINTENANCE);
      if (maintenanceApplication && maintenanceApplication.Products && maintenanceApplication.Products.length > 0) {
        return maintenanceApplication.Products.map(p =>{
          let productAsKey = p.toUpperCase() as keyof typeof MaintenanceProductType;
          return MaintenanceProductType[productAsKey];
        });
      }
    }
    return [];
  }

  private decodeToken(encodedToken: string): TokenBody {
    if (encodedToken != null) {
      const tokenParts: string[] = encodedToken.split('.');
      if (tokenParts[1] != null) {
        const decodedTokenJson = decodeURIComponent(Array.prototype.map.call(atob(tokenParts[1]), function(c) {
          return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        }).join(''));
        return JSON.parse(decodedTokenJson);
      }
    }
    return null;
  }

}
